import styled, { css } from "styled-components";
import { space } from "styled-system";
import propTypes from "@styled-system/prop-types";
import themeGet from "@styled-system/theme-get";
import { ColumnStyle } from "../grid/grid.style";
import { Row, Column } from "../grid";
import { lighten } from "../../../utilities/color";

export const CardRadioOptionStyle = styled.div`
  width: 100%;
  height: 100%;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  justify-content: ${({ centered }) => centered ? "center !important" : "left"};
  align-items: ${({ verticallyCentered }) => verticallyCentered ? "center !important" : "auto"};
  display: ${({ verticallyCentered }) => verticallyCentered ? "flex !important" : "block"};

  .card-radio-option-content {
    text-align: ${({ centered }) => centered ? "center !important" : "left"};
  }

  ${({ error }) => error && css`border-color: #d93737;`};

  ${({ disabled }) => disabled && css`
    pointer-events: none;
    cursor: not-allowed;
    color: ${themeGet("colors.radio.disabled.color", "#8a93a2")};
    background-color: ${(props) => lighten(themeGet("colors.radio.disabled.backgroundColor", "#d8dbe0")(props), 0.08)};
  `};

  &:hover, &:focus, &.selected {
    border: 1px solid #1B4AA8;
  }

  &:hover, &.selected {
    box-shadow: 0 5px 20px rgba(234, 234, 234, 0.8);
  }

  &:focus {
    box-shadow: 0 0 0 3px rgb(39 93 168 / 50%);
  }

  &.selected {
    border-width: 2px;
  }
`;

export const CardRadioStyle = styled(Row, {
  ...propTypes.space,
})`
  ${themeGet("mediaQueries.largeUp")} {
    max-width: 800px;
  }

  ${ColumnStyle} {
    flex-grow: 1;
  }

  /* Style system support */
  ${space}
`;

export const CardRadioErrorStyle = styled(Column)`
  margin-bottom: 15px;
  color: #d93737
`;
